import { ManuteApi } from './src/api';
import { AxiosRequestConfig } from 'axios';

const DEFAULTS: AxiosRequestConfig = {
    baseURL: (process.env.VUE_APP_BASE_URL_API || window.location.origin) + process.env.VUE_APP_PREFIX_URL_API,
    headers: {
        Accept: 'application/json',
    },
};

const api = new ManuteApi(DEFAULTS);

export default api;
